/* @flow */

// Utils
import {
  getUserLoveTalking,
  getUserWantLearn,
  getUserKnowledge,
} from '@braindate/domain/lib/user/util';
import { getKeywordLabel } from 'src/shared/domain/keyword/util/keywordUtils';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import type { Keyword } from 'src/shared/domain/keyword/type/keywordTypes';

export const connectOnInterestFormId = 'connect-on-interest-form';

export const userCanConnectOnInterests = (user: User, locale: string) => {
  const userLoveTalkingAbout = getUserLoveTalking(user, locale);
  const userWantToLearn = getUserWantLearn(user, locale);
  const userKnowledge = getUserKnowledge(user, locale);

  return (
    !!(userLoveTalkingAbout && userLoveTalkingAbout.length) ||
    !!(userWantToLearn && userWantToLearn.length) ||
    !!(userKnowledge && userKnowledge.length)
  );
};

export const userHasInterest = (
  user: User,
  keyword: string,
  locale: string,
) => {
  const userLoveTalkingAbout = getUserLoveTalking(user, locale);
  const userWantToLearn = getUserWantLearn(user, locale);
  const userKnowledge = getUserKnowledge(user, locale);

  if (!userLoveTalkingAbout || !userWantToLearn || !userKnowledge) {
    return;
  }

  const parseKeywords = (keywords: Array<Keyword>) =>
    keywords.map((k) => getKeywordLabel(k));

  const keywords = [
    ...parseKeywords(userLoveTalkingAbout),
    ...parseKeywords(userWantToLearn),
    ...parseKeywords(userKnowledge),
  ];

  return keywords.some((k) => k === keyword);
};
